module.exports = __webpack_public_path__ + "img/android.f3f62505.png";